import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { RechargeformComponent } from '../../../../app/wallet/rechargeform/rechargeform.component';
import { CardItem } from '../../../newship-now/ship-now-popup/Model/Shipitem.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../../app/_services/app.service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { Helpers } from '../../../../app/helpers';
import { Router } from '@angular/router';

@Component({
  selector: 'app-shipnow-popup',
  templateUrl: './shipnow-popup.component.html',
  styleUrls: ['./shipnow-popup.component.scss']
})
export class ShipnowPopupComponent implements OnInit {

  @ViewChild('Rechargewall') AddRecharge: TemplateRef<any>;
  @ViewChild(RechargeformComponent) RechargeformComponent: RechargeformComponent;
  @Input() details: any;
  @Input() cardItems: CardItem[];
  @Input() isMobileView: any;
  // @Output() onCloseEvent = new EventEmitter<any>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() IsRateValid: boolean;
  @Input() IsRechargeBtnShow: boolean;
  CompanyId: any;
  modalRef: any;
  UserId: any;
  data: any = {};
  filterObj: any = {
    FromDate: '',
    ToDate: '',
    __Type: '',
    TransactionTypes: ''
  };

  constructor(
    private modalService: NgbModal,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private toastr: ToastrService,
    private _appService: appService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.UserId = this.decryptpipe.transform(
      JSON.parse(this.cookieService.get("UserId"))
    );
    this.RechargeformComponent.checkPaymentStatus();
    // this.GetWalletList();
  }

  ngAfterViewInit() {
      if (this.RechargeformComponent) {
        this.RechargeformComponent.checkPaymentStatus();
        this.GetWalletList();
      }
      this.GetWalletList();
    }
  
  
    Cancel() {
      this.close.emit(false);
    }
  
    confirm() {
      this.close.emit(true);
    }
  
    navigateTo(route: string) {
      this.router.navigate([route]);
      this.close.emit(true);
    }
  
    Recharge() {
      this.modalRef = this.modalService.open(this.AddRecharge);
      this.close.emit(true);
    }
  
    SaveWalletDetails() {
      this.data.CompanyId = this.CompanyId;
      this.data._type = 'Deposit';
      this.data.Remarks = 'Remarks';
      this.data.status = 'Success';
      this.data.CreatedBy = this.UserId;
  
      // Logging the data before sending it
      console.log('Data to save:', this.data);
  
      // Check for required fields
      if (!this.data.hasOwnProperty('Amount') || this.data.Amount == null) {
        this.toastr.error('Required field: Amount');
        return;
      }
      if (!this.data.CompanyId) {
        this.toastr.error('Required field: CompanyId');
        return;
      }
  
      // Make the API call
      this._appService.Post('OrdersByVehicle', 'SaveWalletDetails', this.data).subscribe(
        (response) => {
          console.log('Response:', response);
          this.toastr.success('Recharge Successfully', 'Success');
          this.GetWalletList();
        },
        (err) => {
          console.error('Error details:', err);
          this.toastr.error('Error occurred while saving data: ' + err.message, 'Error');
        }
      );
    }
  
  
  
    GetWalletList(filterObject: any = this.filterObj,) {
      this._appService.Post('OrdersByVehicle', 'WalletGetList', {
        CompanyId: this.CompanyId,
        FromDate: filterObject.FromDate,
        ToDate: filterObject.ToDate,
        __Type: filterObject.__Type,
        TransactionTypes: filterObject.TransactionTypes,
        CreatedBy: this.UserId
      }).subscribe(
        (response) => {
  
          response.map(x => {
            x.IsActiveString = x.IsActive ? 'Active' : 'Inactive';
          });
          // this.tableDetails.data = response;
          Helpers.setLoading(false);
        },
        (err) => {
          console.log(err)
        }
      )
      // this.getWalletCount();
    }

}
